import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/Logo.png"; // falls du dein Logo verwenden willst

const Navbar = () => {
  return (
    <nav className="navbar-custom">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="DomVault Logo" className="navbar-logo" />
        </Link>

        <div className="navbar-links">
          <Link to="/" className="nav-link">
            Home
          </Link>
          <Link to="/contact" className="nav-link">
            Contact
          </Link>
          <Link to="/impressum" className="nav-link">
            Impressum
          </Link>
          <Link to="/datenschutz" className="nav-link">
            Privacy Policy
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
